// Cart page strings — namespace `cart`. Order-summary copy shared with the
// checkout lives in `checkout.summary`.
export default {
  en: {
    breadcrumbCart: 'Cart',
    title: 'Your cart',
    itemCount: '{count} item | {count} items',
    empty: {
      heading: 'Your cart is empty',
      body: 'Browse the catalog and add a few keys — your selection appears here ready for checkout.',
      cta: 'Browse deals',
    },
    soldBy: 'Sold by',
    removeItem: 'Remove {name}',
    removed: 'Removed from cart',
    undoLimit: 'Couldn’t restore it: the cart is full ({limit} items per order).',
    limitCount: '{count} of {limit} items',
    mini: {
      title: 'Your cart',
      close: 'Close cart',
      subtotal: 'Subtotal',
      checkout: 'Checkout',
      viewCart: 'View cart',
      vatInvoice: 'VAT invoice',
      instant: 'Instant delivery',
      empty: 'Your cart is empty. Add a few keys and they will wait here.',
      browse: 'Browse the catalog',
      signedOut: 'Log in to see your cart.',
      logIn: 'Log in',
    },
    limit: 'Maximum {limit} items per order reached.',
    continueShopping: 'Continue shopping',
    proceed: 'Proceed to checkout',
    recommendations: 'You might also like',
  },
  cs: {
    breadcrumbCart: 'Košík',
    title: 'Váš košík',
    itemCount: '{count} položka | {count} položky | {count} položek',
    empty: {
      heading: 'Váš košík je prázdný',
      body: 'Procházejte katalog a přidejte klíče — váš výběr se zobrazí zde připravený k pokladně.',
      cta: 'Procházet nabídky',
    },
    soldBy: 'Prodává',
    removeItem: 'Odebrat {name}',
    removed: 'Odebráno z košíku',
    undoLimit: 'Položku nelze vrátit: košík je plný ({limit} položek v objednávce).',
    limitCount: '{count} z {limit} položek',
    mini: {
      title: 'Váš košík',
      close: 'Zavřít košík',
      subtotal: 'Mezisoučet',
      checkout: 'K pokladně',
      viewCart: 'Zobrazit košík',
      vatInvoice: 'Faktura s DPH',
      instant: 'Okamžité doručení',
      empty: 'Váš košík je prázdný. Přidejte pár klíčů a počkají tady.',
      browse: 'Procházet katalog',
      signedOut: 'Přihlaste se a uvidíte svůj košík.',
      logIn: 'Přihlásit se',
    },
    limit: 'Dosažen maximální počet {limit} položek v objednávce.',
    continueShopping: 'Pokračovat v nákupu',
    proceed: 'Přejít k pokladně',
    recommendations: 'Mohlo by se vám také líbit',
  },
};
